import { HttpService } from '@pulse/browser-shared';
import { PulseBatch, TrackerConfigurations } from '@pulse/common';
import { DebugService } from '../debug.service';

export type CallbackFunctionType = (params: ResolveWith) => void;
export type ResolveWith = {
    size: number;
    batchId: string;
};

export class PulseTransport {
    constructor(
        private debug: DebugService,
        private config: TrackerConfigurations,
        private httpService: HttpService,
    ) {}

    // Still using callbacks instead of promises because the final
    // beacon request will be ignored if we schedule a micro-task.
    //
    // Will retry requests in case of 5xx errors if possible,
    // and will ignore 4xx errors.

    send(
        batch: PulseBatch,
        keepalive = false,
        done: CallbackFunctionType | undefined = undefined,
        batchId: string,
    ) {
        const url = `${this.config.serverBaseURL}/${this.config.app}`;
        const headers = this.getHeaders();
        const response = this.httpService.post(url, headers, batch.chunks, keepalive);
        response
            .then(() => {
                done?.({ size: batch.size || 0, batchId });
            })
            .catch((err) => {
                console.error(`Batch didn't send ${err}`);
            });
    }

    private getHeaders(): Record<string, string> {
        const receiverDebugEnabled = this.debug.enabled('receiver');

        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'receiver-debug': String(receiverDebugEnabled),
        };

        return headers;
    }
}
